import { useEffect, useRef, useState } from 'react';
import { animate, useReducedMotion } from 'framer-motion';

const COUNT_UP_SECONDS = 0.6;

// The tween takes its start point from a ref, not from `displayed` state: state
// would have to go in the deps below, replaying the tween on its own ticks.
const useNumberTween = (target, restartFrom) => {
    const reducedMotion = useReducedMotion();
    const [displayed, setDisplayed] = useState(restartFrom ?? target);
    const displayedRef = useRef(displayed);

    useEffect(() => {
        if (reducedMotion) {
            displayedRef.current = target;
            setDisplayed(target);
            return undefined;
        }

        const start = restartFrom ?? displayedRef.current;
        displayedRef.current = start;
        setDisplayed(start);

        const controls = animate(start, target, {
            duration: COUNT_UP_SECONDS,
            ease: 'easeOut',
            onUpdate: (value) => {
                displayedRef.current = value;
                setDisplayed(Math.round(value));
            },
        });
        return controls.stop;
    }, [target, restartFrom, reducedMotion]);

    return displayed;
};

export const useTotalCountingUp = (total) => useNumberTween(total);

export const usePointsCountingUpFromZero = (points) => useNumberTween(points, 0);
